// const baseURL = '/api';//本地代理
// const baseURL = 'http://dev-api.cailiangyun.com' //测试环境
const baseURL = 'http://api.cailiangyun.com' //生产环境

//todo  所有接口路径
export default {
  //上传图片
  uploadFile: `${baseURL}/manage/resource/upload`,
  //登录
  loginForm: `${baseURL}/auth/oauth/token`,//账号密码登陆
  logout: `${baseURL}/auth/token/logout`,//退出登陆
  logoutAuto: `${baseURL}/auth/token/logQuit`,//退出登陆
  getLoginCode: `${baseURL}/admin/app/`,////获取登录验证码
  register: `${baseURL}/admin/login/register`,  //注册
  getRegCode: `${baseURL}/admin/app/app/`,//获取注册验证码
  checkIdentity: `${baseURL}/admin/login/data`,//注册登录后选择身份
  refreshToken: `${baseURL}/auth/oauth/token`,//刷新token（延长时间）
  getMenuTree: `${baseURL}/admin/menu`,//系统菜单

  getQrCode: `${baseURL}/admin/applet/qrcode-create`,//获取二维码
  getQrStatus: `${baseURL}/admin/applet/qrcode-status`,//更新二维码状态
  unbindWx: `${baseURL}/admin/user/unbind/`,//微信解除绑定
  getBoundCode: `${baseURL}/admin/applet/bound-create`, //微信绑定二维码
  getBoundStatus: `${baseURL}/admin/applet/bound-status`,//更新微信绑定二维码状态

  reLogin: `${baseURL}/admin/login`,//企业个人身份确认登录

  rePhone: `${baseURL}/admin/user/phone`,//修改手机号
  rePwd: `${baseURL}/admin/user/password`,//修改密码
  getUserInfo: `${baseURL}/admin/user/info`,//用户信息
  editUserInfo: `${baseURL}/admin/user/id`,//修改个人信息

  //公共接口
  getCity: `${baseURL}/admin/city`,//获取省市区树形数据
  getUserList: `${baseURL}/admin/user/page`,// 用户list列表
  getCompanyList: `${baseURL}/admin/enterprise/list`,//公司list

  getSupplierList: `${baseURL}/manage/supplier/list`,//供应商list
  getCustomerList: `${baseURL}/manage/customer/list`,//客户list
  getProductList: `${baseURL}/manage/product/page`,//产品列表
  getProductTree: `${baseURL}/manage/product/list`,//产品以及规格的树

  getVisibleCompanyList: `${baseURL}/admin/enterprise/back/visibleEnterprise`,//可见公司列表


  //财粮说
  getQuotationRecommend: `${baseURL}/finance/quotation/recommend`,//获取首页推荐
  getQuotationSubscribe: `${baseURL}/finance/quotation/subPersonQuotationList`,//获取首页我的订阅列表
  getQuotationDetails: `${baseURL}/finance/quotation/`,//根据id获取报价单详情
  getMyQuotation: `${baseURL}/finance/quotation/myQuotation`,//获取我的报价单列表
  getPersonInfo: `${baseURL}/finance/quotation/personInfo`,//获取我的个人信息
  getMyCollect: `${baseURL}/finance/quotation/myCollect`,//我的收藏报价单列表
  getMyDraft: `${baseURL}/finance/quotation/myDraft`,//我的草稿报价单列表
  getLastQuotation: `${baseURL}/finance/quotation/last`,//导入上一次的报价单
  deleteQuotation: `${baseURL}/finance/quotation/`,//删除报价单
  collectQuotation: `${baseURL}/finance/quotation/collect/`,//收藏报价单
  cancelCollectQuotation: `${baseURL}/finance/quotation/collect/`,//取消收藏报价单
  getQuotationLabels: `${baseURL}/finance/quotation/labels`,//获取标签
  subQuotation: `${baseURL}/finance/quotation/person/sub/`,//订阅报价单
  unSubQuotation: `${baseURL}/finance/quotation/person/cancelSub/`,//取消订阅报价单
  getQuotationTitle: `${baseURL}/finance/quotation/title`,//创建报价单表格下拉框
  addQuotation: `${baseURL}/finance/quotation`,//创建报价单
  searchSubscribe: `${baseURL}/finance/quotation/person/subNumber`,//查询订阅何被订阅人数
  editDraftQuotation: `${baseURL}/finance/quotation`,//编辑草稿

  //编辑一条报价信息
  editRowQuotation: `${baseURL}/finance/quotation/info`,

  getUserDetails: `${baseURL}/admin/user/back/`,//获取个人信息
  updateUser: `${baseURL}/admin/user/id`,//更新个人信息

}



// WEBPACK FOOTER //
// ./src/utils/api.js